/**
 * IssuesAreaTabs — Bereichs-Navigation der Optimierungen (P1/B4):
 * Arbeitsliste | Läufe & Review (mit needs_review-Badge). NavLink-basiert,
 * damit beide Bereiche eigene Routen bleiben (deep-linkbar).
 */
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { usePendingReviewCount } from '@/hooks/usePendingReviewCount'

const tabClass = ({ isActive }: { isActive: boolean }) =>
  `flex items-center gap-2 border-b-2 px-1 pb-2 text-sm font-semibold ${
    isActive
      ? 'border-primary-500 text-neutral-900 dark:text-neutral-100'
      : 'border-transparent text-neutral-500 hover:text-neutral-800 dark:hover:text-neutral-200'
  }`

export function IssuesAreaTabs() {
  const { t } = useTranslation()
  const pending = usePendingReviewCount()

  return (
    <nav aria-label={t('productsIssues.tabs.ariaLabel')} className="flex gap-6 border-b border-neutral-200 dark:border-neutral-800">
      <NavLink to="/v2/products/issues" end className={tabClass}>
        {t('productsIssues.tabs.worklist')}
      </NavLink>
      <NavLink to="/v2/products/issues/runs" className={tabClass}>
        {t('productsIssues.tabs.runs')}
        {pending > 0 && (
          <span
            data-testid="issues-runs-badge"
            className="rounded-full bg-primary-500 px-2 py-0.5 text-2xs font-bold text-white"
          >
            {pending}
          </span>
        )}
      </NavLink>
    </nav>
  )
}
